import { useCallback, useState } from "react";
import { notificationService } from "@/services/notifications";

export interface NotificationState {
  permission: NotificationPermission;
  isSupported: boolean;
  isRequesting: boolean;
}

export const useNotifications = () => {
  const [state, setState] = useState<NotificationState>({
    permission: notificationService.getPermission(),
    isSupported: notificationService.isSupported(),
    isRequesting: false,
  });

  const requestPermission = useCallback(async () => {
    if (state.isRequesting || state.permission === "granted") {
      return state.permission;
    }

    setState((prev) => ({ ...prev, isRequesting: true }));

    try {
      const permission = await notificationService.requestPermission();
      setState((prev) => ({
        ...prev,
        permission,
        isRequesting: false,
      }));
      return permission;
    } catch (error) {
      setState((prev) => ({ ...prev, isRequesting: false }));
      return "denied" as NotificationPermission;
    }
  }, [state.isRequesting, state.permission]);

  const showCustomerUpdateNotification = useCallback(
    async (customerName: string, carInfo: string) => {
      if (state.permission !== "granted") {
        return null;
      }
      return notificationService.showCustomerUpdateNotification(
        customerName,
        carInfo
      );
    },
    [state.permission]
  );

  return {
    ...state,
    requestPermission,
    showCustomerUpdateNotification,
  };
};
